import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import Donate from '../Components/Services/Donate'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'

function Pricing() {
    return (
        <div>
            <HeaderOne />
            <Breadcrumb
                title="Support Us"
            />
            <Donate className="space"/>
            <FooterFour />
            <ScrollToTop />
        </div>
    )
}

export default Pricing
